import { Form } from 'antd';
import React from 'react';
import { ServiceList } from './ServiceList';
import { IQuickBookingV2FormValues, IQuickBookingV2ServiceItem } from '../type';
import { IModalChangeTimeFormValues, ModalChangeTimeRef } from '../TimeDate';
import { QuickBookingV2ServiceItemProps } from './ServiceItem';
import { ChangeServiceModalCallback, ChangeServiceModalRef } from './ChangeServiceModal';
import { IStaffItemData } from 'services/shop/types/staff';
import { find, last } from 'lodash';
import moment from 'moment';
import uuid from 'utils/uuid';
import shopSelectors from 'services/shop/selectors';
type Props = {
  customerId: string;
  name?: any;
  value?: IQuickBookingV2ServiceItem[];
  onChange?: (value: IQuickBookingV2ServiceItem[]) => void;
  modalChangeTimeRef: React.RefObject<ModalChangeTimeRef>;
  onActiveService: QuickBookingV2ServiceItemProps['onActiveService'];
  onOpenChangeStaff?: QuickBookingV2ServiceItemProps['onOpenChangeStaff'];
  changeServiceModalRef: React.RefObject<ChangeServiceModalRef>;
  staffs: IStaffItemData[];
  getListStaff: (serviceId: string, servicesProps?: IQuickBookingV2ServiceItem[]) => void;
};
const CustomerServiceList = ({ customerId, getListStaff, staffs = [], changeServiceModalRef, onActiveService, onOpenChangeStaff, name, value: services = [], onChange = () => undefined, modalChangeTimeRef }: Props) => {
  const anybody = shopSelectors.data.anybody();

  const form = Form.useFormInstance();
  const onOpenChangeTime = (value: IQuickBookingV2ServiceItem) => {
    const formValues: IQuickBookingV2FormValues = form.getFieldsValue();
    const duration = value.masterDuration
      ? value.masterDuration
      : value.duration || 0;
    const startTime = value.masterStartTime
      ? value.masterStartTime
      : value.startTime;
    modalChangeTimeRef.current?.open({
      serviceId: value.serviceId,
      serviceName: value.serviceName,
      startTime,
      timeslots: formValues.timeSlots,
      duration,
    }, (values: IModalChangeTimeFormValues) => {
      const newServices = services?.map((o) => {
        if (o.serviceId === values.serviceId) {
          return {
            ...o,
            masterStartTime: values.startTime,
            masterDuration: values.duration,
          };
        }
        return o;
      }) || [];
      onChange(newServices);
    });
  };

  const onReorder = (value?: IQuickBookingV2ServiceItem[]) => {
    onChange?.(value || []);
  };


  const handleChangeService = (formAdd: (item: IQuickBookingV2ServiceItem) => void): ChangeServiceModalCallback => (newServices) => {
    const formValues: IQuickBookingV2FormValues = form.getFieldsValue();
    let defaultStaff: IStaffItemData | null = null;
    let startDate = formValues.startTime || '';

    if (!services?.length) {
      defaultStaff =
        staffs.find((o) => o.id === formValues.defaultStaffId) || null;
    } else {
      const lastItem = last(services);
      const itemDuration =
        lastItem?.masterDuration || lastItem?.duration || 0;
      startDate = moment(
        lastItem?.masterStartTime || lastItem?.startTime || '',
        'hh:mm A'
      )
        .add(itemDuration, 'minutes')
        .format('hh:mm A');
    }
    newServices?.map((ser) => {
      formAdd({
        id: `${customerId}_${uuid()}`,
        serviceId: ser.serviceId,
        serviceName: ser.serviceName,
        startTime: startDate,
        masterStartTime: '',
        staffId: ser.staffId || defaultStaff?.id || '',
        duration: ser.duration,
        masterDuration: formValues.duration,
        staffName: ser.staffName || defaultStaff?.firstName || '',
        staffAvatar: ser.staffAvatar || defaultStaff?.urlImage || '',
        aptStatus: ser.requestStaff ? 'request' : 'none-request',
        anybody: ser.anybody || defaultStaff?.id?.toString() === anybody?.id?.toString() ? anybody?.anyBody : false,
      });
      if (formValues.duration === undefined) {
        startDate = moment(startDate || '', 'hh:mm A')
          .add(ser.duration, 'minutes')
          .format('hh:mm A');
      }
    });
    const finalServices = form.getFieldValue(['customerList', name, 'services']);

    const emptyStaff = find(finalServices, (o) => !o.staffId);
    if (emptyStaff) {
      form.setFieldValue('activeServiceId', emptyStaff?.id);
      getListStaff(emptyStaff?.serviceId, finalServices);
    }
  };

  return (
    <>
      <Form.List name={[name, 'services']}>
        {(fields, { remove, add }) => (
          <>
            <ServiceList
              fields={fields}
              remove={remove}
              onOpenChangeTime={onOpenChangeTime}
              onActiveService={onActiveService}
              onOpenChangeStaff={onOpenChangeStaff}
              form={form}
              onReorder={onReorder}
              isBookByService={true}
              services={services}
            />
            <button
              className='button-add-service'
              type='button'
              onClick={() => {
                const lastItem = last(services);
                const startTime = form.getFieldValue('startTime') || '';
                const itemDuration =
                  lastItem?.masterDuration || lastItem?.duration || 0;
                const lastItemEndTime = moment(
                  lastItem?.masterStartTime || lastItem?.startTime || startTime || '',
                  'hh:mm A'
                ).add(itemDuration, 'minutes');
                changeServiceModalRef.current?.openWithActive(
                  handleChangeService(add),
                  { lastItemEndTime }
                );
              }
              }
              style={addServiceButtonStyle}
            >
              <IconPlus />
              <span>Add Services</span>
            </button>
          </>
        )}
      </Form.List>
    </>
  );
};

export default CustomerServiceList;
const IconPlus = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.5 4.5C12.9142 4.5 13.25 4.83579 13.25 5.25V18.75C13.25 19.1642 12.9142 19.5 12.5 19.5C12.0858 19.5 11.75 19.1642 11.75 18.75V5.25C11.75 4.83579 12.0858 4.5 12.5 4.5Z'
      fill='#2D6772'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5 12C5 11.5858 5.33579 11.25 5.75 11.25H19.25C19.6642 11.25 20 11.5858 20 12C20 12.4142 19.6642 12.75 19.25 12.75H5.75C5.33579 12.75 5 12.4142 5 12Z'
      fill='#2D6772'
    />
    <path
      d='M12.5 4C13.1904 4 13.75 4.55964 13.75 5.25V10.75H19.25C19.9404 10.75 20.5 11.3096 20.5 12C20.5 12.6904 19.9404 13.25 19.25 13.25H13.75V18.75C13.75 19.4404 13.1904 20 12.5 20C11.8096 20 11.25 19.4404 11.25 18.75V13.25H5.75C5.05964 13.25 4.5 12.6904 4.5 12C4.5 11.3096 5.05964 10.75 5.75 10.75H11.25V5.25C11.25 4.55964 11.8096 4 12.5 4ZM12.25 13.25V18.75C12.25 18.8881 12.3619 19 12.5 19C12.6381 19 12.75 18.8881 12.75 18.75V13.25H12.25ZM13.75 12.25H19.25C19.3881 12.25 19.5 12.1381 19.5 12C19.5 11.8619 19.3881 11.75 19.25 11.75H13.75V12.25ZM12.25 12.25H12.75V11.75H12.25V12.25ZM5.75 11.75C5.61193 11.75 5.5 11.8619 5.5 12C5.5 12.1381 5.61193 12.25 5.75 12.25H11.25V11.75H5.75ZM12.5 5C12.3619 5 12.25 5.11193 12.25 5.25V10.75H12.75V5.25C12.75 5.11193 12.6381 5 12.5 5Z'
      fill='#2D6772'
    />
  </svg>
);

const addServiceButtonStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '12px 16px',
  border: '2px dashed #2D6772',
  borderRadius: '8px',
  background: '#fff',
  cursor: 'pointer',
  width: '100%',
  justifyContent: 'center',
  fontFamily: 'Poppins, sans-serif',
  fontSize: '16px',
  fontWeight: '600',
  color: '#2D6772',
  transition: 'all 0.2s ease'
};
